import React from 'react';
import Footer from '../components/Footer';
import SocialIcons from '../components/SocialIcons';
import aboutContent from '../data/aboutContent';
import escapeImage from '../images/escape.jpg';
import { LandingVariant } from '../utils/landingVariant';
import '../styles/index.css';

interface HomeLinktreeProps {
  variant: LandingVariant;
}

const HomeLinktree: React.FC<HomeLinktreeProps> = ({ variant }) => {
  return (
    <div className='App linktree'>
      <img src={escapeImage} alt='Brinary' className='linktree-art' />
      <h1 className='title'>Brinary</h1>
      <p className='linktree-subtitle'>{aboutContent}</p>
      <SocialIcons variant={variant} layout='buttons' />
      <Footer />
    </div>
  );
};

export default HomeLinktree;
